import { render, staticRenderFns } from "./New.vue?vue&type=template&id=683b342f&scoped=true&"
import script from "./New.vue?vue&type=script&lang=js&"
export * from "./New.vue?vue&type=script&lang=js&"
import style0 from "./New.vue?vue&type=style&index=0&id=683b342f&scoped=true&lang=css&"
import style1 from "./New.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683b342f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('683b342f')) {
      api.createRecord('683b342f', component.options)
    } else {
      api.reload('683b342f', component.options)
    }
    module.hot.accept("./New.vue?vue&type=template&id=683b342f&scoped=true&", function () {
      api.rerender('683b342f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Employee/New.vue"
export default component.exports